(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["image"] && !Shopify.designMode) return;
  try {
    (() => {
    if (!('IntersectionObserver' in window) || !Element.prototype.animate) return;

    const selector = '[data-image-block-fade]';
    const states = new Map();
    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const easingOptions = ['ease-in-out', 'ease-in', 'ease-out', 'linear'];

    function cancel(state) {
      if (state.animation) {
        state.animation.cancel();
        state.animation = null;
      }
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const state = states.get(entry.target);
        if (!state) return;
        if (!entry.isIntersecting) {
          if (state.repeat) cancel(state);
          return;
        }
        if (motionQuery.matches) {
          cancel(state);
          return;
        }
        if (state.played && !state.repeat) return;
        cancel(state);
        state.animation = entry.target.animate(
          [{ opacity: 0 }, { opacity: 1 }],
          {
            duration: state.duration,
            delay: state.delay,
            easing: state.easing,
            fill: 'backwards'
          }
        );
        state.played = true;
        if (!state.repeat) observer.unobserve(entry.target);
      });
    }, { threshold: 0, rootMargin: '0px 0px -24px 0px' });

    function initialize(root) {
      // Clean up replaced blocks before initializing newly rendered content.
      states.forEach((state, target) => {
        if (!target.isConnected) {
          cancel(state);
          observer.unobserve(target);
          states.delete(target);
        }
      });
      const blocks = [];
      if (root.matches && root.matches(selector)) blocks.push(root);
      if (root.querySelectorAll) blocks.push(...root.querySelectorAll(selector));
      blocks.forEach((block) => {
        const target = block.querySelector('.image-block__image, .placeholder-image');
        if (!target || states.has(target)) return;
        states.set(target, {
          block,
          duration: Math.max(200, Number(block.dataset.imageFadeDuration) || 1200),
          delay: Math.max(0, Number(block.dataset.imageFadeDelay) || 0),
          easing: easingOptions.includes(block.dataset.imageFadeEasing) ? block.dataset.imageFadeEasing : 'ease-in-out',
          repeat: block.dataset.imageFadeRepeat === 'true',
          played: false,
          animation: null
        });
        observer.observe(target);
      });
    }

    // Keep linked images visible immediately when reached with a keyboard.
    document.addEventListener('focusin', (event) => {
      const block = event.target.closest ? event.target.closest(selector) : null;
      if (!block) return;
      states.forEach((state, target) => {
        if (state.block !== block) return;
        cancel(state);
        state.played = true;
        if (!state.repeat) observer.unobserve(target);
      });
    });

    motionQuery.addEventListener('change', () => {
      if (motionQuery.matches) states.forEach(cancel);
    });
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      states.forEach((state, target) => {
        if (event.target.contains(state.block)) {
          cancel(state);
          observer.unobserve(target);
          states.delete(target);
        }
      });
    });
    document.addEventListener('shopify:block:select', (event) => {
      initialize(event.target);
      states.forEach((state) => {
        if (event.target === state.block || event.target.contains(state.block)) cancel(state);
      });
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    } else {
      initialize(document);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
